import TFSACalculator from './TFSACalculator';

const calculatorRegistry = {
  'tfsa-canada': {
    component: TFSACalculator,
    afterSectionIndex: 1,
    title: '¿Cuánto deberías aportar a tu TFSA?',
  },
};

export default calculatorRegistry;
